import type { Dispatch, PropsWithChildren, SetStateAction } from "react";
import { createContext, useContext } from "react";
import type { PickRequired } from "../types";
import type { TabsProps } from "./Tabs.types";

const TabIndexContext = createContext<
  | ({
      setActiveIndex: Dispatch<SetStateAction<number>>;
      activeIndex: number;
      uniqueId: string;
    } & Pick<TabsProps, "variant" | "direction" | "size" | "fullWidth"> & {
        underline?: boolean;
      })
  | undefined
>(undefined);

export const TabProvider = ({
  children,
  ...props
}: PropsWithChildren<
  {
    activeIndex: number;
    setActiveIndex: Dispatch<SetStateAction<number>>;
    underline?: boolean;
    uniqueId: string;
  } & PickRequired<TabsProps, "direction" | "variant" | "size" | "fullWidth">
>) => {
  return <TabIndexContext.Provider value={props}>{children}</TabIndexContext.Provider>;
};

export const useTabContext = () => {
  const context = useContext(TabIndexContext);

  if (!context) {
    throw new Error("useTabContext must be used within a TabProvider");
  }

  return context;
};
